import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { DateTime, Duration } from 'luxon';
import DatePicker from '../date-picker';

const DobPicker = function DobPicker(props) {
    const {
        children,
        validation,
        invalidclass,
    } = props;

    const validateInput = (event, error) => {
        let newError = error;

        if (!error) {
            const { value } = event.target;

            const minDob = DateTime.local().minus(Duration.fromObject({ years: 18 }));
            const dt = DateTime.fromISO(value);

            newError = minDob < dt ? 'You must be over 18 years old' : '';
        }

        if (validation) {
            validation(event, newError);
        }
    };

    // use the useCallback hook to memoize the validateInput function
    // refer to react/jsx-no-bind eslint error
    const validationCallback = useCallback((event, error) => validateInput(event, error), []);

    return (
        <DatePicker
            name="dateofbirth"
            maxyear={DateTime.local().minus(Duration.fromObject({ years: 18 })).year}
            minyear={1900}
            validation={validationCallback}
            invalidclass={invalidclass}
        >
            {children}
        </DatePicker>
    );
};

DobPicker.propTypes = {
    children: PropTypes.node.isRequired,
    validation: PropTypes.func,
    invalidclass: PropTypes.string,
};

DobPicker.defaultProps = {
    validation: () => { },
    invalidclass: '',
};

export default DobPicker;
